module.exports = __webpack_public_path__ + "img/20221115楼书2.c65f01ca.png";